import React, { useId } from 'react';
import { fractionScore } from '../utils/fractionScore';

export default function FractionScoreInput({ label, value, onChange }: any) {
  const id = useId();
  const result = fractionScore(value);
  return (
    <div className="sge-fraction-field">
      <label htmlFor={id}>Points earned / possible</label>
      <input id={id} type="text" inputMode="text" placeholder="e.g. 2/3"
        aria-label={label} value={value} onChange={event => onChange(event.target.value)}
        aria-invalid={Boolean(result.error)} aria-describedby={result.error ? `${id}-error` : undefined} />
      {result.error && <span id={`${id}-error`} className="sge-fraction-error" role="alert">{result.error}</span>}
    </div>
  );
}
